import React from 'react';
import { FiMinusCircle } from "react-icons/fi";
import { FiPlusCircle } from "react-icons/fi";
import styled from 'styled-components';

const CartQuantityToggle = ({quantity,setDecrease,setIncrease,updateQuantity}) => {
  return (
    <Wrapper>
    <div className='cart-quantity'>
        <div className='Quantity-toggle'>
            <button className='icon_button' onClick={()=>setDecrease()}><FiMinusCircle /> </button>
            {/* Editable input field */}
            <input
              type="text"
              min="1"
              className="Quantity-style"
              value={quantity}
              onChange={(e) => {
                const newQty = Number(e.target.value);
                if (newQty > 0) {
                  updateQuantity(newQty); // direct update
                }
              }}
            />
            <button className='icon_button' onClick={()=>setIncrease()}>< FiPlusCircle/></button>
        </div>
      
    </div>
    </Wrapper>
  )
}
const Wrapper=styled.div`

.Quantity-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    }

.Quantity-style {
    min-width: 4rem;
    max-width: 7rem;
    background-color: #fff;     
    color: #000;                   
    box-shadow: inset 0 1px 3px rgba(0,0,0,0.1); 
    border-radius: 0.5rem;         
    font-size: 1.5rem;
    text-align: center;
   }

  .icon_button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 2rem;
    color:${({ theme }) => theme.colors.bgd};
    }

  .icon_button:hover {
    color: #0056b3;
     align-items: center;
     justify-content: center;
  }

 
`;
export default CartQuantityToggle
